import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { LoadingBar } from '../ui/loading-bar';

export function Layout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <LoadingBar />
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        {/* top bar */}
        <header className="flex h-14 shrink-0 items-center justify-between border-b border-line bg-surface/80 px-7 backdrop-blur">
          <nav className="flex items-center gap-2 text-xs">
            <span className="font-semibold text-ink">Lead Ops Console</span>
          </nav>

          <div className="flex items-center gap-3">
            <span className="text-xs text-muted">Stage A Admin</span>
          </div>
        </header>

        {/* work surface */}
        <main id="work" className="grain flex-1 overflow-y-auto px-7 py-7">
          <div className="mx-auto">
            <Outlet />
          </div>
        </main>

        {/* build stamp (epic 028) — px-7 matches the header's horizontal padding */}
        <footer className="px-7 py-2 text-xs text-muted">
          build {import.meta.env.VITE_BUILD_SHA || 'unknown'}
        </footer>
      </div>
    </div>
  );
}
